const en = {
    //general
    text_out_of: "out of",
    text_general: "General",
    text_attendance_qr_code: "Attendance QR Code",
    text_general_datail: "General Details",
    text_geo_restriction: "Geo Restriction",
    text_distan_allow_scan: "Distance Allow Scan",
    text_number_of_late_allow: "Number of Late Allow",
    text_minimum_duration_before_checkout: "Duration Before Checkout(mns)",
    text_attendance_setting: "Attendance Setting",
    text_accept_duration: "Accept Duration",
    text_acceptDifferenceTime: "acceptDifferenceTime",
    text_break_time_setting: "Break Time Setting",
    text_break_time: "Break Time",
    text_workingTimeIn: "WorkingTimeIn",
    text_workingTimeOut: "workingTimeOut",
    text_select_project: "Select project",
    text_please_select_date_and_search_employee: "Please select date and search employee",
    text_please_select_employee: "Please select employee",
    text_please_select_date_and_employee: "Please select date and employee",
    text_day: "Day",
    text_end_working_day: "End Working Day",
    text_exportable: "Exportable",
    text_column_width: "Column Width",
    text_column_width_place_holder: "Width as px",


    // Salary Scale Record

    text_salary_scale_record: "Salary Scale Record",

    //approval
    text_approval_setting: "Approval Setting",
    text_comment: "Comment",
    text_location_status: "Location Status",
    text_select_role: "Select a Role for Approver",
    text_comment_required: "Comment Required",
    text_cancellation_setting: "Cancellation Setting",
    text_select_role_request: "Select a Role for Request cancellation",
    text_select_role_review: "Select a Role for Review Request",
    text_review_setting: "Review Setting",
    text_to_approve_request: "to approve request",
    text_to_reject_request: "to reject request",
    text_reason_mandatory_for_cancellation: "Reason mandatory for cancellation",
    text_enable_approvals_for_cancellation: "Enable approvals for cancellation",
    text_enable_review_level: "Enable review level",
    text_success_update: "Success Update!",
    text_success_reset_password: "Success Reset Password!",
    text_upload_an_image: "Upload an image",
    text_expectedWorkingHourPerMonth: "Expected Working Hour Per Month",
    text_expectedWorkingDayPerMonth: "Expected Working Days Per Month",
    text_please_input_expectedWorkingHourPerMonth:
        "Please input expected working hour per month!",
    text_please_input_expectedWorkingDayPerMonth: "Please input expected working days per month!",
    text_working_hours: "Working Hours",
    text_please_select_title: "Please select title!",
    text_do_you_have_any_note_for_your_order: "Do you have any note for your order?",
    text_do_you_have_any_note_for_your_sale: "Do you have any note for your sale?",


    //name
    text_name: "Name",
    text_nameKH: "Name In Khmer",
    text_employee: "Employee",
    text_employee_id: "Staff ID",
    text_employee_name: "Staff Name",
    text_company_name: "Company Name",
    text_edit_location: "Edit Location",
    text_new_location: "New Location",
    text_company_name_khmer: "Company Name in Khmer",
    text_dealer_name: "Dealers Name",
    text_shop_name: "Shop Name",
    text_name_Kh: "Name Khmer",
    text_display_name: "Display Name",
    text_private_url: "Private URL",
    text_contacts_information: "Contacts Information",

    //Departments
    text_departments: "Departments",
    text_edit_department: "Edit Department",
    text_new_department: "New Department",

    //product & type
    text_product_type: "Product Type",
    text_brand: "Band",
    text_model: "Model",
    text_price: "Price",
    text_finance_amount: "Finance Amount",
    text_please_input_remark: "Please input remark!",

    //gender
    text_gender: "Gender",
    text_male: "Male",
    text_female: "Female",
    text_clockIn: "Clock In",
    text_clockOut: "Clock Out",
    //notifiacation
    text_notification: "Notification",
    text_no: "No.",
    text_no_data: "No Data",
    //address
    text_address: "Address",
    text_distance_allow_scan: "Distance Allow Scan",
    text_contact: "Contact",
    text_enable_upload_photo: "Enable Upload Photo",
    text_employees: "Employees",
    text_import_project: "Import Project",
    text_allocated_projects: "Import Allocated Projects",
    text_upload_a_spreatsheet_to_import_employees_donor: "Upload a spreadsheet to import employees’ donor.",
    text_upload_a_spreatsheet_to_import_employees: "Upload a spreadsheet to import employees.",
    text_upload_a_spreatsheet_to_import_employees_payroll_annual_leave: "Upload a spreadsheet to import employees’ payroll annual leave.",


    // Salary Tax Rate

    text_salary_tax_rate: "Salary Tax Rate",
    text_monthly_salary: "Monthly Salary (KHR)",
    text_salary_tax_rate_new: "New Salary Tax Rate",
    text_salary_tax_rate_edit: "Edit Salary Tax Rate",
    text_please_input_from: "Please input from!",
    text_please_input_to: "Please input to!",


    //title
    text_title: "Title",
    text_import_employee_payroll: "Import Employees’s Payroll",
    text_import_payroll: "Import Payroll",
    text_import_payroll_accrual: "Import Payroll Accrual",
    text_import_payroll_annual_leave: "Import Payroll Annual Leave",
    text_import_overtime: "Import Overtime",
    text_amount: "Amount",
    text_payslip_period: "Payroll Period",
    text_edit_payslip: "Edit Payroll",
    text_view_payslip: "View Payroll",
    text_payroll_setting: "Payroll Setting",
    text_payroll_calculation: "Payroll Calculation",
    text_salary_base: "Salary Base",
    text_working_day_base: "Working Day Base",
    text_print: "Print",

    //Home
    text_dashboard: "Dashboard",
    text_task_statistic: "Task Statistic",
    text_heres_your_analytic_details: "Here’s your analytic details",
    text_total_tasks: "Total Tasks",

    //code
    text_code: "Code",
    text_please_input_duty_station_code: "Please input duty station code!",
    text_work_period: "Work Period",
    text_employee_code: "Employee Code",
    text_dealer_code: "Dealers Code",
    text_id: "ID",
    text_update_employee: "Update Employee",
    text_new_employee: "New Employee",
    text_current_address: "Current Address",
    text_enter_current_address: "Enter current address",
    text_date_of_birth: "Date of Birth",
    text_place_of_birth: "Place of Birth",
    text_enter_place_of_birth: "Enter place of birth",
    text_select_nationality: "Select nationality",
    text_religious: "Religion",
    text_enter_religious: "Enter religion",
    text_national_id_number: "National ID Number",
    text_bank_acc_no: "Bank Acc No.",
    text_notify_email: "Notify Email",
    text_enter_notify_email: "Enter notify email",
    text_enter_national_id_number: "Enter national ID number",
    text_passport_information: "Passport Information",
    text_expired_date: "Expired Date",
    text_select_passport_type: "Select passport type",
    text_passport_number: "Passport Number",
    text_enter_passport_number: "Enter passport number",
    text_date_of_issued: "Date of Issued",
    text_place_of_issued: "Place of Issued",
    text_enter_place_of_issued: "Enter place of issued",
    text_visa_information: "Visa Information",
    text_select_visa_type: "Select visa type",
    text_visa_number: "Visa Number",
    text_enter_visa_number: "Enter visa number",
    text_contact_number_1: "Contact Number 1",
    text_enter_contact_number_1: "Enter contact number 1",
    text_contact_number_2: "Contact Number 2",
    text_enter_contact_number_2: "Enter contact number 2",
    text_contact_number_3: "Contact Number 3",
    text_enter_contact_number_3: "Enter contact number 3",
    text_personal_email: "Personal Email",
    text_enter_personal_email: "Enter personal email",
    text_emergency_contact_name: "Emergency Contact Name",
    text_enter_emergency_contact_name: "Enter emergency contact name",
    text_emergency_contact_number: "Emergency Contact Number",
    text_enter_emergency_contact_number: "Enter emergency contact number",
    text_spouse_and_kids_information: "Spouse and Kids Information",
    text_spouse_name: "Spouse Name",
    text_enter_spouse_name: "Enter spouse name",
    text_working: "Working",
    text_select_working: "Select working",
    text_occupation: "Occupation",
    text_enter_spouse_occupation: "Enter spouse occupation",
    text_sibling_parents_and_other_information: "Sibling, Parents and Other Information",
    text_nssf_number: "NSSF Number",
    text_enter_nssf_number: "Enter NSSF number",
    text_workbook_number: "Workbook Number",
    text_enter_workbook_number: "Enter workbook number",
    text_workpermit_number: "WorkPermit Number",
    text_tax_identification_number: "Tax Identification Number",
    text_enter_tax_identification_number: "Enter tax identification number",
    text_enter_workpermit_number: "Enter work permit number",
    text_mother_name: "Mother Name",
    text_enter_mother_name: "Enter mother name",
    text_father_name: "Father Name",
    text_enter_father_name: "Enter father name",
    text_next_of_king_information: "Next of Kin Information",
    text_kid_name: "Kid Name",
    text_current_status: "Current Status",
    text_under_controll: "Under Control",
    text_out_of_controll: "Out of Control",
    text_select_current_status: "Select current status",
    text_please_enter_kid_name: "Please enter kid name!",
    text_please_select_date_of_birth: "Please select date of birth!",
    text_provident_fund_staff: "Provident Fund Staff",
    text_provident_fund_npa: "Provident Fund NPA",
    text_please_select_current_status: "Please select current status!",
    text_new_kid: "New Kid",
    text_update_kid: "Update Kid",
    text_new_sibling: "New Sibling",
    text_update_sibling: "Update Sibling",
    text_new_next_of_king: "New Next of King",
    text_update_next_of_king: "Update Next of King",
    text_enter_name: "Enter name",
    text_please_enter_name: "Please enter name!",
    text_please_enter_national_id_number: "Please enter national id number!",
    text_inheritance: "Inheritance",
    text_enter_inheritances: "Enter inheritance",
    text_please_enter_inheritance: "Please enter inheritance",
    text_education_information: "Education Information",
    text_national_education: "National Education",
    text_institute: "Institute",
    text_enter_institute: "Enter institute",
    text_eg_bachelor_of_arts_in_english: "e.g. Bachelor of Arts in English",
    text_date_s_placeholder: "e.g. June 2021 to May 2014,2001 - 2004 .etc",
    text_degree: "Degree",
    text_date_s: "Date(s)",
    text_short_course_certification: "Short Course/Certification",
    text_name_of_certification: "Name of certification",
    text_certifying_authority: "Certifying Authority",
    text_certifying_authority_placeholder: "Name of organization issuing the certification",
    text_languages: "Languages",
    text_language: "Language",
    text_eg_khmer: "e.g. Khmer",
    text_proficiency: "Proficiency",
    text_sibling_name: "Name of Sibling",
    text_skills: "Skills",
    text_eg_computer_skill: "e.g. Computer Skill",
    text_level: "Level",
    text_level_placeholder: "e.g. Beginner, Advance, Medium .etc",
    //leave type number
    text_entilement: "Entitlement",
    text_carry_forward: "Carry Forward",
    text_type: "Type",
    text_order: "Order",
    text_number_of_dealers: "Number Of Dealers",
    text_submit_date: "Submit Date",
    text_contact_number: "Contact Number",
    //date and month
    text_start: "Start Date",
    text_end: "End Date",
    text_target_of_month: "Target Of Month",

    //last updated
    text_last_updated: "Last Updates",

    //sale target
    text_sale_staff: "Sale Staff",
    text_general_staff: "General Staff",
    text_guard: "Guard",
    text_staff: "Staff",
    text_assigned_dealers: "Assigned Dealers",
    text_application_in: "Application In",
    text_performance: "Performance",
    text_collection_target: "Collection Target",
    text_project: "Project",
    text_sale_target: "Sale Target",
    text_sale_target_amount: "Sale Target Amount",

    //Employee
    text_position: "Position",
    text_age: "Age",
    text_join_date: "Join Date",
    text_probation: "Probation",
    text_date: "Date",
    text_basic_salary: "Basic Salary",
    text_effective_salary_date: "Effective Salary Date",
    text_payroll_currency: "Payroll Currency",
    text_currency: "Currency",
    text_base_hour_rate: "Base Hour Rate",
    text_base_day_rate: "Base Day Rate",
    text_clock_in: "Clock In-Out",
    text_single: "Single",
    text_Married: "Married",
    text_separated: "Separated",
    text_marital_status: "Marital Status",
    text_select_marital_status: "Select marital status",
    text_number_of_kid: "Number Of Kid",
    text_contract_type: "Contract Type",
    text_select_contract_type: "Select contract type",
    text_udc: "UDC",
    text_fdc: "FDC",
    text_volunteer: "Secondment",
    text_consultant: "Consultant",
    text_internship: "Internship",
    text_contract_end_date: "Contract End Date",
    text_contract_changed_at: "Contract Changed At",
    text_please_select_contract_end_date: "Please select contract end date!",
    text_please_select_contract_changed_at: "Please select contract changed at!",
    text_last_working_day: "Last Working Day",
    text_please_select_last_working_day: "Please select last working day!",
    text_select_last_working_day: "Select last working day",

    //Report
    report: "Report",
    text_current_balance: "Current Balance",
    text_leave_type: "Leave Type",
    text_location_visit_report: "Location Visit Report",
    text_distance_clockIn_out: "Distance",
    text_dd_mm_yyyy: "dd/mm/yyyy",
    text_ca_invention: "CA INVENTION",
    text_Period: "Period:",
    text_mm_yyyy: "mm/yyyy",
    text_yyyy_mm_dd: "yyyy/mm/dd",
    text_photo: "Photo",
    text_select_location: "Select location",
    text_select_role_component: "Select role",

    text_select_team: "Select team",
    text_select_code: "Select code",
    text_please_select_code: "Please select code!",
    text_username: "Username",
    text_username_is_required: "Username is required!",
    text_please_enter_your_username: "Please enter your username",
    text_password_is_required: "Password is required!",
    text_password: "Password",
    text_payroll: "Payroll",
    text_average_wage: "Average Wage",
    text_total: "Total",
    text_date_of_payment: "Date of Payment:",
    text_employees_name: "Employee's Name:",
    text_positon: "Positon:",
    text_upload_a_spreatsheet_to_import_employees_payroll: `Upload a spreadsheet to import employees’ payroll.`,
    text_upload_a_spreatsheet_to_import_employees_overtime: `Upload a spreadsheet to import employees’ overtime.`,

    //Setting
    text_setting: "Setting",
    text_update_your_company_profile_and_other_setting:
        "Update your company profile and other setting",
    text_work_schedule: "Work Schedule",
    text_startWorkingDay: "StartWorkingDay",
    text_endWorkingDay: "endWorkingDay",
    text_endWorkingHaftDay: "endWorkingHaftDay",
    text_new_job_level: "New Job Level",
    text_edit_job_level: "Edit Job Level",
    text_job_grade: "Job Grade",
    text_step: "Step",
    text_new_job_grade: "New Job Grade",
    text_edit_job_grade: "Edit Job Grade",

    // Team
    text_edit_team: "Edit Team",
    text_new_team: "New Team",
    text_department: "Department",
    text_team: "Team",
    text_teams: "Teams",
    text_role: "Role",
    text_roles: "Roles",
    text_what_is_your_team_name: "What is your team name?",
    text_select_department: "Select department",
    text_please_input_team_name: "Please input team name!",
    text_please_select_department: "Please select department!",
    text_upload_files_drag_and_drop: ` Drag and drop a file(CSV,XLSX or XLS) anywhere, browse your
  files.`,
    text_choose_a_file_to_upload: "Choose a File to Upload",
    text_success_import: "Success Import!",

    // Branch
    text_edit_branch: "Edit Branch",
    text_new_branch: "New Branch",
    text_branches: "Branches",
    text_branch: "Branch",
    text_select_branch: "Select branch",
    text_branch_address: "Address",
    text_latitude: "Latitude",
    text_longitube: "Longitude",
    text_geolocation: "Geolocation",
    text_enter_your_company_branch: "Enter your company branch",
    text_where_is_your_branch: "Where is your branch?",

    text_please_input_company_branch: "Please input company branch!",
    text_please_input_address: "Please input address!",
    text_please_input_latitude: "Please input latitude!",
    text_please_input_longitude: "Please input longitude!",

    // Overtime Type
    text_edit_overtime_type: "Edit Overtime Type",
    text_new_overtime_type: "New Overtime Type",
    text_over_time_types: "Overtime Types",
    text_over_time_type: "Overtime Type",
    text_overtime_request: "Overtimes",
    text_rate: "Rate",
    text_geolocation_in: "Geolocation In",
    text_geolocation_out: "Geolocation Out",
    text_approval_process: 'Approval Process',
    text_nssf: "NSSF",
    text_accident: "Accident",
    text_health: "Health",
    text_time: "Time",
    text_duration: "Duration",
    text_holiday: "Holiday",
    text_normal: "Normal",
    text_night_shift: "Night Shift",
    text_day_off: "Day Off",
    text_compensation: "Compensation",
    text_late_permission: "Late Permission",
    text_early_permission: "Early Permission",
    text_overtime_type_name_in_english: "Overtime type name in English",
    text_overtime_type_name_in_khmer: "Overtime type name in Khmer",
    text_select_type: "Select type",
    text_how_much_rate_ot_you_provide_hour: "How much rate OT you provide/hour?",
    text_start_time: "Start Time",
    text_end_time: "End Time",

    text_please_input_name_in_english: "Please input name in English!",
    text_please_input_name_in_khmer: "Please input name in Khmer!",
    text_please_select_type: "Please select type!",
    text_please_input_rate: "Please input rate!",
    text_please_select_start_time: "Please select start time!",
    text_please_select_end_time: "Please select end time!",

    // Leave
    text_request_date: "Request Date",
    text_requested_date: "Requested Date",
    text_leave_request: "Leave Request",
    text_new_request: "New Request",
    text_new_leave_request: "New Leave Request",
    text_edit_leave_request: "Edit Leave Request",
    text_from_date: "From Date",
    text_to_date: "To Date",
    text_approved_leave: "Approved",
    text_mark_as_cancelled: "Mark as Cancelled",
    text_approve_cancel: "Approve Cancel",
    text_rejected_leave: "Rejected",
    text_request_cencel: "Request Cancel",
    text_leaves: "Leaves",
    text_leave: "Leave",
    text_leave_summary: "Leave Summary",
    text_leaves_request: "Leaves",
    text_leave_remain: "Leave Remain",
    text_attachment: "Attachment",
    text_type_of_leave: 'Type of Leave',
    text_select_leave_type: 'Select Leave Type',
    text_please_select_leave_type: "Please select leave type",
    text_please_tell_us_about_reason_of_taking_leave: "Please tell us about reason of taking leave",
    text_request_no: 'Request No.',
    text_staff_id: "Staff ID",
    text_staff_name: "Staff Name",
    text_staff_email_id: 'Staff Email ID',
    text_request_by: 'Request By',
    text_leave_from: "Leave From",
    text_leave_to: "Leave To",
    text_approval_id: "Approval ID",
    text_last_balance: "Last Balance",
    text_balance_this_leave: "Current Balance",
    text_hr_comment: "Approver's comment",

    text_reason: "Reason",
    text_pending_leave: "Pending",
    text_approver: "Approver",
    text_submitted_date: "Submitted Date",
    text_approved_date: "Approved Date",
    text_approved_by: "Approved By",
    text_rejected_by: "Rejected By",
    text_cancelled_by: "Cancelled By",
    text_approval_date: "Approval Date",
    text_rejected_date: "Rejected Date",
    text_cancelled_date: "Cancelled Date",
    text_number_day: "Number of Day",
    text_taken: "Taken",
    text_tell_requestor_about_rejected_reason_here: "Tell requestor about your rejected reason here...",
    text_what_is_your_reject_reason: "What is your reject reason",

    //payslip
    text_total_base_pay: "Total Base Pay",
    text_gross_pay: "Gross Pay",
    text_netpay: "Net Pay",
    text_text_netpay_upper: "NET PAY",
    text_monthly: "Monthly",
    text_select_month: "Select Month",

    // Payroll Item
    text_edit_payroll_item: "Edit Payroll Item",
    text_new_payroll_item: "New Payroll Item",
    text_formular: "Formula",
    text_offered_by: "Offered By",
    text_government: "Organization",
    text_payroll_item: "Payroll Elements",
    text_select_formular: "Select formula",
    text_earning: "Earning",
    text_other_earning: "Other Earning",
    text_taxable_deduction: "Taxable Deduction",
    text_non_taxable_defuction: "Non-Taxable Deduction",
    text_deduction: "Deduction",
    text_none: "None",
    text_pension_fund: "Pension Fund",
    text_allowance: "Allowance",
    text_tax_rate: "Tax Rate",
    text_other_deduction: "Other Deduction",
    text_deduction_upper: "DEDUCTION",
    text_taxable_earning: "Taxable Earning",
    text_non_taxable_earning: "Non-Taxable Earning",
    text_taxable_earning_upper: "TAXABLE EARNING",
    text_non_taxable_earning_upper: "NON-TAXABLE EARNING",
    text_sub_total_taxable_earning: "SUB-TOTAL TAXABLE EARNING",
    text_sub_total_non_taxable_earning: "SUB-TOTAL NON TAXABLE EARNING",
    text_sub_total_deduction: "SUB-TOTAL DEDUCTION",
    text_remark: "REMARK",
    text_round: "Round",
    text_please_input_round: "Please input round!",
    text_new_pension_fund: "New Pension Fund",
    text_edit_pension_fund: "Edit Pension Fund",
    text_payroll_type: "Payroll Type",
    text_one_time: "One Time",
    text_two_time: "Two Time",
    text_label_remark: "Remark",
    text_visa_type: "Visa Type",
    text_new_visa_type: "New Visa Type",
    text_edit_visa_type: "Edit Visa Type",
    text_passport_type: "Passport Type",
    text_new_passport_type: "New Passport Type",
    text_edit_passport_type: "Edit Passport Type",
    text_nationality: "Nationality",
    text_ethnicity: "Ethnicity",
    text_enter_ethnicity: "Enter ethnicity",
    text_new_nationality: "New Nationality",
    text_edit_nationality: "Edit Nationality",

    text_remain: "Remain",
    text_scan_setting: "Scan Setting",
    text_scan_option: "Scan Option",
    text_tap_in_scan: "Tap in App",
    text_scan_qr: "Scan QR",
    text_exclude_item: "Exclude Item",
    text_payroll_item_in_english: "Payroll item in English",
    text_payroll_item_in_khmer: "Payroll item in Khmer",
    text_by_default_it_auto_generate_from_name_in_English: "By default it auto generate from name in English",

    text_please_select_formular: "Please select formula!",
    text_please_select_role: "Please select role!",
    text_please_enter_remain: "Please enter remain!",
    text_please_enter_amout: "Please enter amount!",

    // Project
    text_edit_donor: "Edit Donor",
    text_new_donor: "New Donor",
    text_projects: "Projects",
    text_enter_your_project_no: "Enter your project no.",
    text_what_is_your_donor_name: "What is your donor name?",
    text_project_name: "Project Name",
    text_pay_items: "PAY ITEMS",

    text_please_input_project_no: "Please input project no.!",
    text_please_input_donor_name: "Please input donor name!",
    text_please_input_payroll_item_in_english: "Please input payroll item in English!",
    text_please_input_payroll_item_in_khmer: "Please input payroll item in Khmer!",

    // Role

    text_permissions: "Permissions",
    text_please_input_role_name: "Please input role name!",
    text_new_role: "New Role",
    text_update_role: "Update Role",
    text_no_permission: "No permission",
    text_sorry_you_are_not_authorized_to_access_this_page: "Sorry, you are not authorized to access this module.",

    // Leave Types
    text_leave_types: "Leave Types",
    text_edit_leave_type: "Edit Leave Type",
    text_new_leave_type: "New Leave Type",
    text_leave_type_name: "Leave type name",
    text_please_input_leave_name: "Please input leave name!",
    text_please_input_number_allow: "Please input number allow!",
    text_how_many_day_allowe_for_employee_leave: "How many day allow for employee leave?",
    text_do_you_allow_remain_leave_for_reuse_next: "Do you allow remain leave for reuse next?",
    text_annual: "Annual",
    text_annual_leave: "Annual Leave",
    text_other_annual: "Other Annual",
    text_special: "Special Leave",
    text_maternity: "Maternity",
    text_maternity_leave: "Maternity Leave",
    text_paternity_leave: "Paternity Leave",
    text_unpaid: "Unpaid",
    text_compensation_leave: "Compensation Leave",
    text_job_seeking_leave: "Job Seeking Leave",

    // Tasks
    text_detail_task: "Detail Task",
    text_Check_In_Out: "Check-In/Out",
    text_task_information: "Task Information",
    text_task_result: "Task Result",
    text_task_name: "Task Name",
    text_task_list: "Task List",
    text_preset: "Preset",
    text_tasks: "Tasks",
    text_assignee: "Assignee",
    text_number_of_week: "Number of Week",
    text_number_of_day: "Number of Day",
    text_enter_number_of_day: "Enter number of day you take leave",
    text_start_date: "Start Date",
    text_end_date: "End Date",
    text_due_date: "Due Date",
    text_estimated_time: "Estimated Time",
    text_anytime: "Anytime",
    text_yesterday: "Yesterday",
    text_today: "Today",
    text_tomorrow: "Tomorrow",
    text_success_create: "Success Create!",
    text_import_task: "Import Tasks",
    text_upload_a_spreatsheet_to_import_employees_tasks: "Upload a spreadsheet to import employees’ tasks.",
    text_custom: "Custom",
    text_date_rate: "Date Rate",
    text_select_status: "Select status",
    text_new_tasks: "New Tasks",
    text_new_task: "New Task",
    text_edit_task: "Edit Task",
    text_assign_to: "Assign To",
    text_search_customer: "Search Employee",
    text_please_search_employee: "Please search employee!",
    text_please_select_start_date: "Please select start date!",
    text_please_select_ot_from: "Please select OT from!",
    text_please_select_ot_to: "Please select OT to!",
    text_please_select_due_date: "Please select due date!",
    text_location: "Location",
    text_please_enter_a_task_name: "Please enter a task name",
    text_please_enter_a_task_name_error_message: "Please enter a task name!",
    text_please_select_date: "Please select date!",
    text_search_location: "Search Location",
    text_please_search_location: "Please search location!",
    text_timesheet: "Timesheet",
    text_field_force: "Field Force",
    text_version: "Version 1.0",
    text_private_url_is_required: "Private url is required!",
    text_ex_ca_mp_mega: "EX.ca,mp,mega",
    text_log_in: "Log In",
    text_ca_invention_copyright: "PANJAC PLAN CO., LTD. © 2023 All Rights Reserved.",
    text_position_placeholder: "e.g. Operation Manager, Payroll Assistant etc",
    text_please_input_company_code: "Please input company code!",
    text_please_input_company_name: "Please input company name!",
    text_products_to_count: "Products To Count",
    text_probation_expired_date: "Probation Expired Date",
    text_select_head_of_department: "Select head of department",
    text_head_of_department: "Head Of Department",
    text_line_manager: "1st Line Manager",
    text_project_manager: "Project Manager",
    text_supervisor: "Supervisor",
    text_select_supervisor: "Select supervisor",
    text_base_role: "Base Role",
    text_please_select_base_role: "Please select base role!",
    text_select_base_role: "Select base role",
    text_please_select_branch: "Please select branch!",
    text_process_payroll: "Process Payroll",
    text_sold_date: "Sold Date",
    text_sale_detail: "Sale Detail",
    text_seller: "Seller",
    text_sales: "Sales",
    text_sold_products: "Sold Products",
    text_sale_product: "Sale Product",
    text_sale_quantity: "Sale Quantity",
    text_location_information: "Location Information",
    text_location_name: "Location Name",
    text_response_on_Project: "Response On Project",

    // Status
    text_pending: "Pending",
    text_request: "Request",
    text_completed: "Completed",
    text_reviewed: "Reviewed",
    text_review: "Review",
    // text_mark_as_reviewed: "Mark as Review",
    text_in_progress: "In Progress",
    text_approved: "Approved",
    text_number_of_request_time_allow: "Number Of Request Time Allow",
    text_all: "All",
    text_valid_attendance: "Valid Attendance",
    text_rejected: "Rejected",
    text_cancelled: "Cancelled",
    text_absent_employees: "Absent Employees",
    text_attendance_statistic: "Attendance Statistic",
    text_request_for_approval: "Request for Approval",
    text_verified: "Verified",
    text_mark_as_verified: "Mark as Verified",
    text_locations: "Locations",
    text_download_file_xlsx: "Download File(xlsx)",
    text_successfully_exported_payroll_report: "Successfully Exported Payroll Report",
    text_successfully_exported_presence_hours_break_up: "Successfully Exported Presence hours break-up Report",
    text_successfully_exported_detail_attendance_report: "Successfully Exported Detail Attendance Report",
    text_successfully_exported_working_hour_report: "Successfully Exported Working Hour Report",
    text_successfully_exported_working_overtime_details: "Successfully Exported Overtime Details",
    text_successfully_exported_working_overtime_summary: "Successfully Exported Overtime Summary",
    text_successfully_exported_late_early_check_in_and_check_out: "Successfully Exported Late/Early Check-In and Check-Out Report",
    text_successfully_exported_locations: "Successfully Exported Locations",

    // Public Holidays

    text_public_holidays: "Public Holidays",
    text_edit_holiday: "Edit Holiday",
    text_new_holiday: "New Holiday",
    text_please_input_name: "Please input name!",
    text_please_select_end_date: "Please select end date!",
    text_once_deleted_you_will_not_be_able_to_recover_this_imaginary_file: "Once deleted, you will not be able to recover this imaginary file!",
    text_processed: "Processed",
    text_country_director: "Country Director",
    text_general_manager: "General Manager",
    text_hr_manager: "HR Manager",
    text_employee_id_already_exist: "Employee ID already exist!",

    //Action
    text_title_already_exist: "Title already exist!",
    text_action: "Actions",
    text_duplicate: "Duplicate",
    text_display: "Display",
    text_process: "Process",
    text_add_new: "Add New",
    text_new_objective: "New Objectives",
    text_cancel: "Cancel",
    text_save: "Save",
    text_yes_approve: "Yes, approve!",
    text_back: "Back",
    text_edit: "Edit",
    text_update: "Update",
    text_delete: "Delete",
    text_filter: "Filter",
    text_reset: "Reset",
    text_apply: "Apply",
    text_search: "Search",
    text_confrim: "Are you sure?",
    text_mark_as_passed_probation: "Mark as Passed Probation",
    text_you_wont_be_able_to_revert_this: "You won't be able to revert this!",
    text_status: "Status",
    text_generate: "Generate",
    text_reject: "Reject",
    text_approve: "Approve",
    text_mark_as_approved: "Mark as Approved",
    text_request_for_cancel: "Request for Cancel",
    text_mark_as_reviewed: "Mark as Reviewed",
    text_import: "Import",
    text_download_template: "Download Template",
    text_save_and_close: "Save & Close",
    text_save_and_new: "Save & New",
    text_clear: "Clear",
    text_remove: "Remove",
    text_add_task: "Add Task",
    text_view: "View",
    text_personal_detail: "Personal Detail",
    text_personal_information: "Personal Information",
    text_employee_level: "Employee Level",
    text_working_information: "Working Information",
    text_other: "Other",
    text_terminate: "Terminate",
    text_work_shift: "Work Shift",
    text_start_setup: "Start Setup",
    text_submit: "Submit",
    text_absent: "Absent",
    text_dayoff: "Day off",
    text_modules: "Modules",
    text_yes: "Yes",
    text_No: "No",
    text_presence: "Presence",
    text_request_time: "Request Time",
    text_enter_a_unique_id: "Enter a unique ID",
    text_please_enter_full_name: "Enter full name",
    text_enter_a_unique_id_i: "Enter a unique ID",
    text_full_name_kh: "Full Name KH",
    text_enter_first_name: "Enter first name",
    text_enter_last_name: "Enter last name",
    text_please_enter_full_name_kh: "Please enter full name kh!",
    text_please_input_geolocation: "Please input geolocation!",
    text_payroll_period: "Payroll Period",
    text_child: "Child",
    text_select_child: "Select child",

    // Attendance reports
    text_attendance_reports: "Attendance Reports",
    text_attendance_report: "Attendance Report",
    text_late_early_check_in_and_check_out: "Late/Early Check-In and Check-Out",
    text_employee_present_absent_status: "Employee Present/Absent Status",
    text_employee_present_absent_status_lower: "Employee present/absent status",
    text_presence_hours_break_up: "Presence Hours Break-Up",
    text_presence_hours_break_up_lower: "Presence hours break-up",
    text_working_hour_dashboard: "Working Hour Report",
    text_overtime_details: "Overtime Details",
    text_overtime_summary: "Overtime Summary",
    text_check_in: "Check In",
    text_check_out: "Check Out",
    text_total_hours: "Total Hour",
    text_overtime_in: "Overtime In",
    text_overtime_out: "Overtime Out",
    text_entry: "Entry",
    text_entry_late: "Entry Late",
    text_exit_early: "Exit Early",
    text_leave_early: "Leave Early",
    text_exit_late: "Exit Late",
    text_late: "Late",
    text_early: "Early",
    text_exit: "Exit",
    text_net_hours: "Net Hours",
    text_worked_days: "Worked Days",
    text_first_in: "First In",
    text_late_out: "Late Out",
    text_break: "Break",
    text_permission: "Permission",
    text_payable_hours: "Payable Hours",
    text_overtime: "Overtime",
    text_actual: "Actual",
    text_month: "Month",
    text_date_range: "Date Range",
    text_worked_hour: "Worked Hours",
    text_paid_leave: "Paid Leave",
    text_unpaid_leave: "Unpaid Leave",
    text_normal_overtime: "Normal",
    text_holiday_overtime: "Holiday",
    text_night_overtime: "Nighttime",
    text_dayoff_overtime: "Dayoff",
    text_entry_early: "Entry Early",
    text_exchange_rate: "Exchange Rate",
    text_nssf_exchange_rate: "NSSF Exchange Rate",
    text_payrol_period: "Payroll Period",
    text_please_select_payrol_period: "Please select period",
    text_please_input_exchange_rate: "Please input exchange rate!",
    text_enable_working_haft_day_at_weekend: "Enable Working Haft Day At Weekend",

    text_daily_attendance_status: "Daily Attendance Status",
    text_presenceed_in_a_pie_chart_format: "presented in a pie chart format",
    text_details_of_those_who_have_come_late_or_early: "details of those who have come late or early",
    text_details_of_late_entry_early: "details of late entry, early",
    text_able_filter_option_to_filter_based_on_date_location_etc: "able filter option to filter based on date, location, etc.",
    text_attendance_details_of_all_users_for_an_entire_month: "attendance details of all users for an entire month",
    text_you_can_cycle_through_various_months_using_the_direction_markers: "you can cycle through various months using the direction markers",
    text_choose_from_either_day_or_hour_view: "choose from either day or hour view",
    text_see_the_hours_employees_have_worked: "see the hours employees have worked",
    text_see_the_hours_employees_have_payable_hours: "see the hours employees have payable hours",
    text_see_the_hours_employees_have_permission_time_etc: "see the hours employees have permission time, etc.",
    text_insight_into_attendance_details_of_users: "insight into attendance details of users",
    text_number_of_employees_who_are_present_today: "number of employees who are present today",
    text_number_of_employees_who_are_on_duty: "number of employees who are on duty",
    text_number_of_employees_who_are_on_leave_etc: "number of employees who are on leave, etc.",
    text_gives_detailed_information_about_the_total_no_of_payable_days: "gives detailed information about the total no of payable days",
    text_see_the_total_no_of_worked_days: "see the total no of worked days",
    text_see_the_total_no_of_expecting_working_days_etc: "see the total no of expecting working days, etc.",
    text_denors_budget_allocation: "Donors/Budget Allocation",
    text_project_name_code: "Project Name/Code",
    text_project_code: "Project Code",
    text_sub_project_code: "Sub Project Code",
    text_percentage_of_allocate: "Budget Allocation",
    text_enter_percentage_of_allocate: "Enter allocation",
    text_contract_termination_notice_period: "Contract Termination's Notice Period",
    text_notice_of_termination: "Notice of Termination",
    text_notice_termination_at: "Notice Termination At",
    text_select_yes_no: "Select Yes/No",
    text_termination_benefit: "Termination Benefit",
    text_short_absent_notice_period: "Short/Absent Notice Period",
    text_select_notice_period: "Select notice period",
    text_approval_leave_ot: "Approver(Leave, Overtime)",
    text_approval_pdd: "Approver PDD",
    text_acting_by: "Acting By",
    text_acting_start: "Acting Start",
    text_acting_end: "Acting End",
    text_1st_line_manager: "1st Line Manager",
    text_2nd_line_manager: "2nd Line Manager",
    text_select_2nd_line_manager: "Select 2nd line manager",
    text_3rd_line_manager: "3rd Line Manager",
    text_select_3rd_line_manager: "Select 3rd line manager",
    text_4th_line_manager: "4th Line Manager",
    text_select_4th_line_manager: "Select 4th line manager",
    text_5th_line_manager: "5th Line Manager",
    text_select_5th_line_manager: "Select 5th line manager",
    text_select_1st_line_manager: "Select 1st line manager",
    text_please_select_1st_line_manager: "Please select 1st line manager",
    text_select_project_manager: "Select project manager",
    text_select_job_grade: "Select job grade",
    text_select_step: "Select step",
    text_job_level: "Job Level",
    text_select_job_level: "Select job level",
    text_date_of_employment: "D.O.E",
    text_employee_type: "Employee Type",
    text_type_of_worker: "Type of Worker",
    text_select_type_of_worker: "Please select type of worker",
    text_select_employee_type: "Select employee type",
    text_department_programme: "Department/Programme",
    text_select_department_programme: "Select department/programme",
    text_duty_station: "Station Duty",
    text_select_duty_station: "Select duty station",
    text_working_day: "Working Day",
    text_select_working_day: "Select working day",
    text_employment_status: "Employment Status",
    text_number_of_working_day: "Number of Working Day",
    text_enter_number_of_working_day: "Enter number of working Day",
    text_select_employment_status: "Select employment status",
    text_activities_code: "Activities Code",
    text_activity_code: "Activity Code",
    text_enter_activity_code: "Enter activity code",

    // Leave Report
    text_leave_reports: "Leave Reports",
    text_overtime_report: "Overtime Report",
    text_payroll_report: "Payroll Report",
    text_settings: "Settings",
    text_backup_restore: "Backup",
    text_search_by_employee: "Search by employee",
    text_leave_report: "Leave Report",
    text_daily_leave_status: "Daily Leave Status",
    text_resource_availability: "Resource Availability",
    text_employee_leave_balance: "Employee Leave Balance",
    text_employee_book_balance: "Employee Booked and Balance",
    text_leave_employee: "Employee",
    text_aproval_status: "Approval Status",
    text_please_select_benefit: "Please select benefit!",
    text_new_benefit: "New Benefit",
    text_benefit_already_exist: "Benefit already exist!",

    text_actual_working_day: "Actual Working Day",
    text_total_working_day: "Total Working Day",
    text_sick_leave: "Sick Leave",
    text_approved_dil: "Approved DIL",
    text_late_deduction: "Late Deduction",

    // sales force
    text_reports: "Reports",
    text_sales_force: "Sales Force",
    text_send_sale: "Send Sale",
    text_products: "Products",
    text_product: "Product",
    text_orders: "Orders",
    text_order_detail: "Order Detail",
    text_stock_count: "Stock Count",
    text_product_name: "Product Name",
    text_unit: "Unit",
    text_barcode: "Barcode",
    text_new_product: "New Product",
    text_edit_product: "Edit Product",
    text_enter_product_name: "Enter product name",
    text_please_enter_product_name: "Please enter product name!",
    text_please_enter_unit: "Please enter unit!",
    text_enter_barcode_for_product: "Enter barcode for product",
    text_duty_station_setting: "Duty Station",
    text_new_duty_station_setting: "New Duty Station",
    text_edit_duty_station_setting: "Edit Duty Station",

    // Weekday

    text_mon: "Mon",
    text_tue: "Tue",
    text_wed: "Wed",
    text_thu: "Thu",
    text_fri: "Fri",
    text_sat: "Sat",
    text_sun: "Sun",
    text_monday: "Monday",
    text_tuesday: "Tuesday",
    text_wednesday: "Wednesday",
    text_thursday: "Thursday",
    text_friday: "Friday",
    text_saturday: "Saturday",
    text_sunday: "Sunday",

    // Shift
    text_shift: "Shift",
    text_shift_name: "Shift Name",
    text_hours_before_the_shift_start: "hours before the shift start",
    text_hours_before_the_shift_end: "hours before the shift end",
    text_shift_from: "From",
    text_shift_to: "To",
    text_shift_margin: "Shift Margin",
    text_shift_enable: "Enable",
    text_shift_disable: "Disable",
    text_edit_shift: "Edit Shift",
    text_new_shift: "New Shift",
    text_weekend_definition: "Weekend Definition",
    text_weekend_day: "Weekend day",
    text_please_input_shift_name: "Please input shift name!",
    text_please_select_working_time_in: "Please select time in!",
    text_please_select_working_time_out: "Please select time out!",
    text_time_in: "Time In",
    text_time_out: "Time Out",
    text_days: "Days",
    text_hours: "Hours",
    text_weeks: "Weeks",
    text_1st: "1st",
    text_2nd: "2nd",
    text_3rd: "3rd",
    text_4th: "4th",
    text_5th: "5th",
    text_applicable_for: "Applicable For",
    text_please_select_shift: "Please select",
    text_please_select_shift_waring: "Please select!",
    // Profile

    text_personal: "Personal",
    text_full_name: "Full Name",
    text_first_name: "First Name",
    text_last_name: "Last Name",
    text_first_name_kh: "First Name KH",
    text_last_name_kh: "Last Name KH",
    text_account: "Account",
    text_enter_account: "Enter account for access system",
    text_birthday: "Birthday",
    text_phone_number: "Phone Number",
    text_contacts: "Contacts",
    text_company: "Company",
    text_benefit: "Benefit",
    text_compensation_benefit: "Compensation & Benefit Information",
    text_log_out: "Log out",
    text_change_password: " Change Password",
    text_profile: "Profile",

    // Change Password

    text_current_password: "Current Password",
    text_new_password: "New Password",
    text_confirm_password: "Confirm Password",
    text_your_current_password_does_not_match:
        "Your current password doesn't match",
    text_please_input_your_password: "Please input your password!",
    text_please_input_your_current_password:
        "Please input your current password!",
    text_please_input_your_new_password: "Please input your new password!",
    text_please_input_your_confirm_password:
        "Please input your confirm password!",
    text_your_confirm_password_does_not_match:
        "Your confirm password doesn't match",
    text_please_enter_current_password: "Please enter current password",
    text_please_enter_new_password: "Please enter new password",
    text_please_enter_new_password_again: "Please enter new password again",

    // Overtime Request
    text_overtime_for: "Overtime For",
    text_description: "Description",
    text_for_payment: "For Payment",
    text_for_Leave: "For Leave",
    text_anouncement: "Announcement",

    //total
    text_total_employee: "Total Employee",
    text_outlet: "Outlet",
    text_total_outlet: "Total Outlets",
    text_total_Project: "Total Project",
    text_new_hire: "New Hire",
    text_export_report: "Export Report",
    text_export_employees: "Export Employees",
    text_successfully_exported_employees: "Successfully Exported Employees",
    text_export: "Export",
    text_payabble: "Payable",
    text_outlet_information: "Outlet Information",

    // Donor

    text_donor: "Donor",
    text_donor_name: "Donor Name",
    text_project_no: "Project No.",
    text_scale_level: "Scale Level",
    text_scale_column: "Scale Column",
    text_history_before: "Before",
    text_history_current: "Current",
    text_modified_by: "Modified By",
    text_modified_at: "Modified At",
    text_import_donor: "Import Donor",
    text_import_employees: "Import Employees",

    // Orders

    text_outlet_name: "Outlet Name",
    text_order_date: "Order Date",
    text_ordered_products: "Ordered Products",
    text_order_quantity: "Order Quantity",
    text_format: "Format",
    text_select_format: "Select format",
    text_please_select_format: "Please select format!",

    // Stock Count
    text_count_date: "Count Date",
    text_counted_quantity: "Counted Quantity",
    text_stock_count_detail: "Stock Count Detail",
    text_counted_date: "Counted Date",
    text_counted_projects: "Counted Products",
    text_please_enter_product_quantity_at_lest_one:
        "Please enter product quantity at lest one!",
    text_order_products: "Order Product",
    text_send_order: "Send Order",
    text_please_input_description: "Please input description!",
    text_reset_password: "Reset Password",
    text_active: "Active",
    text_deactive: "Deactive",
    text_resigned: "Inactive",
    text_inactive: "Inactive",
    text_ok: "Ok",
    text_usd: "USD",
    text_khr: "KHR",
    text_percentage: "PERCENTAGE",
    text_role_and_privileges: "Role and Privileges",
    text_privileges: "Privileges",
    text_employee_profile: "Employee Profile",
    text_permanent_staff: "Permanent Staff",
    text_providend_fund: "Providend Fund",
    text_select_benifit: "Select benefit",
    text_enter_amount: "Enter amount",
    text_tax_on_salary: "Tax on Salary",
    text_tax_on_ftb: "Tax on FTB",
    text_offered_tax_by: "Offered Tax By",
    text_insurance: "Insurance",
    text_proficiency_placeholder: "e.g. Mother-tongue, Native, Fluently",
    text_job_profile: "Job Profile",
    text_attachment_of_education_certificate: "Attachment of Education Certificate",
    text_attachment_of_benefit_information: "Attachment of Benefit Information",


    // PDF

    text_preview_pdf: "Preview PDF",
    text_monthly_location_visit_report: "MONTHLY LOCATION VISIT REPORT",
    text_monthly_workin_hour_report: "MONTHLY WORKING HOUR REPORT",
    text_monthly_orders: "MONTHLY ORDERS",
    text_monthly_late_early_check_in_and_check_out: "MONTHLY LATE EARLY CHECK IN AND CHECK OUT",
    text_monthly_presence_hour_breakup: "MONTHLY PRESENCE HOUR BREAKUP",
    text_monthly_overtime_details: "MONTHLY OVERTIME DETAILS",
    text_monthly_overtime_summary: "MONTHLY OVERTIME SUMMARY",

    // calendar
    // Day
    text_su: 'Su',
    text_mo: 'Mo',
    text_tu: 'Tu',
    text_we: 'We',
    text_th: 'Th',
    text_fr: 'Fr',
    text_sa: 'Sa',
    // month
    text_jan: 'Jan',
    text_feb: 'Feb',
    text_mar: 'Mar',
    text_apr: 'Apr',
    text_May: 'May',
    text_jun: 'Jun',
    text_jul: 'Jul',
    text_aug: 'Aug',
    text_sep: 'Sep',
    text_oct: 'Oct',
    text_nov: 'Nov',
    text_dec: 'Dec',
};

export default en;
